export default __webpack_public_path__ + "static/media/EAST2460.34I-34263_-18487_0.f06e0c35.jpg";